<template>
	<Row :gutter="[16, 8]">
		<Col :span="18" :offset="0" >
			<TimeSeriesChart v-if="mountpointsSelected.length > 0" :isLoading="isLoading" :series="series" :options="chartOptions" :height="500" />
			<EmptyChartFiltersMessage v-else messageKey="gnss-visibility.mountpointsPlaceholder.gridpoint" />
		</Col>
		<Col :span="6" :offset="0">
			<VerticalLayout>
				<Card :bordered="false">
					<VerticalLayout>
						<TypographyText v-if="!multiCnetEnabled">
							<InfoCircleOutlined class="pd-sm-x pd-left-0" />{{ $t('home-map.messages.noDataForCNet') }}
						</TypographyText>
						<CNetSelectStoreBound
							:disabled="!multiCnetEnabled"
							:onChange="clearSelectedMountpoints"
						/>
						<div class="flex-wrapper">
							<div class="flex-grow">
								{{ $t('gnss-visibility.mountpointsLabel.gridpoint') }}
							</div>
							<Button size="small" @click="onSelectAll">
								{{ $t('gnss-visibility.mountpointsSelectAllLabel') }}
							</Button>
						</div>
						<Select
							class="width-100"
							v-model:value="mountpointsSelected"
							mode="multiple"
							:allowClear="true"
							:options="mountpointsOptions"
							:placeholder="$t('gnss-visibility.mountpointsPlaceholder.gridpoint')"
							@change="gnssVisibilityTimeSeriesGet"
						/>

						<GnssSelect ref="gnssSelectRef" :onChange="gnssVisibilityTimeSeriesGet" />

						<DateRangeChooser v-if="showDateRangeChooser" v-model="datesRange" @change="gnssVisibilityTimeSeriesGet" />
					</VerticalLayout>
				</Card>
			</VerticalLayout>
		</Col>
	</Row>
</template>

<script>
import { watch } from 'vue';

import { Row, Col, Card, Select, Button, TypographyText } from 'ant-design-vue';
import { InfoCircleOutlined } from '@ant-design/icons-vue';

import Consts from '@/api/Consts';
import { useSubNetworksStore } from '@/stores/subNetworksStore';
import { useGnssVisibilityChartGroup } from '@/utils/useGnssVisibilityChartGroup';

import VerticalLayout from '@/components/common/VerticalLayout';
import GnssSelect from '@/components/common/controls/GnssSelect.vue';
import CNetSelectStoreBound from '@/components/common/controls/CNetSelectStoreBound.vue';
import DateRangeChooser from '@/components/common/DateRangeChooser';

import EmptyChartFiltersMessage from '@/components/charts/EmptyChartFiltersMessage';
import TimeSeriesChart from '@/components/stats/TimeSeriesChart';


export default {
	components: {
		Row, Col, Card, Select, Button, TypographyText,
		VerticalLayout, GnssSelect, DateRangeChooser, TimeSeriesChart, EmptyChartFiltersMessage,
		InfoCircleOutlined, CNetSelectStoreBound,
	},
	props: {
		showDateRangeChooser: {
			type: Boolean,
			required: false,
			default: true,
		},
		minDate: {
			type: Date,
			required: false,
		},
		maxDate: {
			type: Date,
			required: false,
		},
	},
	setup(props) {
		const multiCnetEnabled = Consts.MULTI_CNET_ENABLED;
		const subNetworksStore = useSubNetworksStore();
		const chartGroup = useGnssVisibilityChartGroup({
			props,
			apiMode: 'gridpoint',
			getMountpointsOptions: () => subNetworksStore.gridpointsSelectOptions,
			initMountpointSelectedRef: null,
		});
		watch(() => subNetworksStore.subNetworkSelectedId, () => {
			chartGroup.clearSelectedMountpoints();
		});

		return {
			multiCnetEnabled,
			...chartGroup,
		};
	},
}
</script>
